import RootProjectsDB from '@/firebase/root-projects-db'

export default {
  /**
   * Fetch projects of current loggedin user
   */
  getRootProjects: async ({ commit }) => {
    const rootProjectDb = new RootProjectsDB()

    const projects = await rootProjectDb.readAll()
    commit('setProjects', projects)
  },

  getIDProject: async ({ commit }) => {
    const rootProjectDb = new RootProjectsDB()

    const UID = await rootProjectDb.getUID()
    commit('initIDProject', UID)
  },

  /**
   * Create a project for current loggedin user
   */
  createUserProject: async ({ commit }, project) => {
    const userProjectDb = new RootProjectsDB()

    commit('setProjectCreationPending', true)
    const createdProject = await userProjectDb.create(project)
    commit('addProject', createdProject)
    commit('setProjectCreationPending', false)
  },

  /**
   * Create a new project for current loggedin user and reset project name input
   */
  triggerAddProjectAction: ({ dispatch, state, commit }) => {
    if (state.project === state.defaultProject) return

    const project = JSON.parse(JSON.stringify(state.project))
    commit('setDataProjectToCreate', state.defaultProject)
    dispatch('createUserProject', project)
  },

  /**
   * Delete a user project from its id
   */
  deleteUserProject: async ({ commit, getters }, projectId) => {
    if (getters.isProjectDeletionPending(projectId)) return

    const rootProjectsDB = new RootProjectsDB()

    commit('addProjectDeletionPending', projectId)
    await rootProjectsDB.delete(projectId)
    commit('removeProjectById', projectId)
    commit('removeProjectDeletionPending', projectId)
  }
}
